import React, { useState, useEffect, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
// materialui table
import MaterialTable from "@material-table/core";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  Paper,
  CardHeader,
  FormHelperText,
} from "@mui/material";

import { DeleteOutline, Edit, ViewList, ViewListSharp, ViewComfySharp} from "@mui/icons-material";

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";
import {
  KeyboardTimePicker,
} from "components/pickers";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";
import { cellFocusEditor, dateEditor } from "../../../services/Common";
import PrescriptionItemModal from "../../../services/PrescriptionItemModal";
import ProtocolModal from "../../../services/ProtocolModal";
import ProductSelectInPrescriptionModal from "../../../services/ProductSelectInPrescriptionModal";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { useTranslation } from "react-i18next";

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { getARVFacilityList } from "../../../services/Common";
let tmpItemMasterId = 0;

const PrescriptionForm = ({
  setFormData,
  AddRecord,
  patientData,
  formData,
  handleChange,
  handleDateChange,
  handleCheck,
  handleSubmit,
  handleReset,
  handleRDateChange,
  changePrescriptionStatus,
  showProductListModel,
  setShowProductListModel,
  updatePrescription,
  handleDetailChange,
  handleDetailDropDownChange,
  handleDetailCheck,
  selectedProducts,
  setSelectedProducts,
  selectedProtocols,
  setSelectedProtocols,
  showProtocolListModel,
  setShowProtocolListModel,
  errorObject,
  productAdd,
  setUpdatedDetailsGridDataHandler,
  ...props
}) => {
  const { t } = useTranslation();
  const formBusy = !!(props.controlLoading || props.isSubmitting);
  // console.log("Prescription formData from PrescriptionForm.js: ", formData);
  // console.log("Prescription patientData from PrescriptionForm.js: ",patientData );

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  // const lan = "fr_FR";
  const menukey = "prescriptions";

  const PrescriptionItemsRefHolder = useRef({ table: null });
  const PrescriptionItemsRef = PrescriptionItemsRefHolder.current;

  const classes = useStyles();
  //const FacilityList = JSON.parse(localStorage.getItem("FacilityList"));
  const FacilityList = getARVFacilityList();
  const PrescriberList = JSON.parse(localStorage.getItem("PrescriberList"));
  const DispenserList = JSON.parse(localStorage.getItem("DispenserList"));
  const IntervalList = JSON.parse(localStorage.getItem("IntervalList"));
  const DirectionList = JSON.parse(localStorage.getItem("DirectionList"));
  const FacilityId = localStorage.getItem("FacilityId");
  const FacilityName = localStorage.getItem("FacilityName");
  const RouteOfAdminlist = JSON.parse(localStorage.getItem("RouteOfAdminlist"));
  const SourceList = JSON.parse(localStorage.getItem("SourceList"));
  const Itemlist = JSON.parse(localStorage.getItem("Itemlist"));
  
  const [selectedPrescriptionItem, setSelectedPrescriptionItem] = useState({});
  const [selectedItemBatches, setSelectedItemBatches] = useState([]);
  const [getCurrFormData, setCurrFormData] = useState(formData);

  const [protocolId, setProtocolId] = useState();
  const [RegimenId, setRegimenId] = useState();
  const [open, setOpen] = useState(false);
  const [openProtocol, setOpenProtocol] = useState(false);
  const [openProductBatches, setopenProductBatches] = useState(false);
  const [currFormulation, setCurrFormulation] = useState("");
  const [currRowId, setCurrRowId] = useState(0);
  // const [productLabel, setProductLabel] = useState("");
  const [bIsDisable, setbIsEnable] = useState(false);
  const [manyTableData, setManyTableData] = useState([]);
  const [deletedDataSet, setDeletedDataSet] = useState([]);
  const [isLoadingIndicator, setIsLoadingIndicator] = useState(false);
  const [itemMasterId, setItemMasterId ] = React.useState(0);

  const [toggleBtnValue, setToggleBtn] = React.useState("1");

  const handleClose = (modalname) => {
    switch (modalname) {
      case "Products":
        setOpen(false);
        break;
      case "ProductsOpen":
        setOpen(true);
        break;

      case "Protocol":
        setOpenProtocol(false);
        break;
      case "ProtocolOpen":
        setOpenProtocol(true);
        break;

      case "ProductBatch":
        setopenProductBatches(false);
        break;
      case "ProductBatchOpen":
        setopenProductBatches(true);
        break;

      default:
        break;
    }
  };

  /* =====Start of Print Excel Many Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintMany = () => {
    let finalUrl = EXCEL_EXPORT_URL + "report/prescription_details_print.php";

    window.open(
      finalUrl +
        "?menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&PrescriptionId=" +
        props.match.params.id +
        "&FacilityId=" +
        FacilityId +
        "&TimeStamp=" +
        Date.now()
    );
  };

  /* =====End of Excel Export Code==== */

  const addProduct = (NonOrderProductData) => {
    // console.log("NonOrderProductData: ", NonOrderProductData);
    if (!NonOrderProductData) {
      return;
    }

    let temNonordata = NonOrderProductData;
    let rows = [];

    //start for new items
    let autoId = Date.now(); //0;
    temNonordata.forEach((row, i) => {
      autoId++; //autoId--;
      let newRow = {};

      newRow.id = autoId * -1; // Id Minus means it is new item
      newRow.productId = ""; //row.ItemNo;
      newRow.formulation = row.ItemShortName;
      newRow.type = "product"; //row.ItemCode;
      newRow.qty = 1;
      newRow.UnitPrice = 0; //row.UnitPrice;
      newRow.uom = row.UnitName;
      newRow.AdministrationUnit = row.AdministrationUnit;
      newRow.intervalId = 1;
      newRow.dur = 1;
      newRow.rep = 0;
      newRow.calc = 0;
      newRow.product = ""; //row.ItemName;
      newRow.dispQty = "";
      newRow.directionId = 1;
      newRow.pcks = "";
      newRow.bp = 0;
      newRow.nd = 0;
      newRow.ICDCode = "";
      newRow.PacksizeName = 0; //row.PacksizeName;
      newRow.RouteId = 1; //row.RouteId;
      newRow.BatchNo = "";
      newRow.ExpiryDate = "";
      newRow.SourceId = "";
      newRow.SourceName = "";
      newRow.CurrentStockQty = 0;
      newRow.BatchInfo = null;
      newRow.ProductTypeId = 0;

      rows.push(newRow);
    });

    //=================start for existing items
    autoId = Date.now(); // autoId = 0;
    manyTableData.forEach((row, i) => {
      autoId++;
      let newRow = {};
      newRow.id = row.id;
      newRow.productId = row.productId;
      newRow.formulation = row.formulation;
      newRow.type = row.type;
      newRow.qty = row.qty;
      newRow.UnitPrice = row.UnitPrice;
      newRow.uom = row.uom;
      newRow.AdministrationUnit = row.AdministrationUnit;
      newRow.intervalId = row.intervalId;
      newRow.dur = row.dur;
      newRow.rep = row.rep;
      newRow.calc = row.calc;
      newRow.product = row.product;
      newRow.dispQty = row.dispQty;
      newRow.directionId = row.directionId;
      newRow.pcks = row.pcks;
      newRow.bp = row.bp;
      newRow.nd = row.nd;
      newRow.ICDCode = row.ICDCode;
      newRow.PacksizeName = row.PacksizeName;
      newRow.RouteId = row.RouteId;
      newRow.BatchNo = row.BatchNo;
      newRow.ExpiryDate = row.ExpiryDate;
      newRow.SourceId = row.SourceId;
      newRow.SourceName = row.SourceName;
      newRow.CurrentStockQty = row.CurrentStockQty;
      newRow.BatchInfo = row.BatchInfo;
      newRow.ProductTypeId = row.ProductTypeId;

      rows.push(newRow);
    });
    //=================end for existing items

    // console.log("rows after pick product: ", rows);

    setManyTableData(rows);
    productAdd(rows);
    handleClose("Products");
  };

  const { refetch: fetchProtocolItemsData } = useQuery(
    ["prescriptions", protocolId],
    () =>
      api.getProtocolItems(protocolId).then((protocolItems) => {
        // console.log("protocolItems: ", protocolItems);
        if (!protocolItems) {
          return null;
        }
        setProtocolId(-1); //protocolId reset in state after pick, because same protocol again pick not work in a time
        setRegimenId(-1);

        let rows = [];

        //start for new items
        let autoId = Date.now(); //0;
        protocolItems.forEach((row, i) => {
          autoId++; // autoId--;
          let newRow = {};

          newRow.id = autoId * -1; // Id Minus means it is new item
          newRow.productId = "";
          newRow.formulation = row.ItemShortName;
          newRow.type = "product";
          newRow.qty = row.formulationQty;
          newRow.UnitPrice = row.UnitPrice;
          newRow.uom = row.UnitName;
          newRow.AdministrationUnit = row.AdministrationUnit;
          newRow.intervalId = row.IntervalId;
          newRow.dur = row.Duration;
          newRow.rep = 0;
          newRow.calc = row.CalcQty;
          newRow.product = row.ItemName;
          newRow.dispQty = row.productQty;
          newRow.directionId = row.DirectionId;
          newRow.pcks = row.packs;
          newRow.bp = row.bp;
          newRow.nd = 0;
          newRow.ICDCode = "";
          newRow.PacksizeName = row.PacksizeName;
          newRow.RouteId = row.RouteId;
          newRow.BatchNo = row.BatchNo;
          newRow.ExpiryDate = row.ExpiryDate;
          newRow.SourceId = row.SourceId;
          newRow.SourceName = row.SourceName;
          newRow.CurrentStockQty = row.CurrentStockQty;
          newRow.BatchInfo = null;
          newRow.ProductTypeId = 0;


          rows.push(newRow);
        });

        //start for existing items
        let existingItemsDelete = deletedDataSet; //here deletedDataSet because, if first delete some items then pick regimen. for delete existing items when pick regimen
        autoId = Date.now(); //autoId = 0;
        manyTableData.forEach((row, i) => {
          autoId++;
          let newRow = {};
          newRow.id = row.id;
          newRow.productId = row.productId;
          newRow.formulation = row.formulation;
          newRow.type = row.type;
          newRow.qty = row.qty;
          newRow.UnitPrice = row.UnitPrice;
          newRow.uom = row.uom;
          newRow.AdministrationUnit = row.AdministrationUnit;
          newRow.intervalId = row.intervalId;
          newRow.dur = row.dur;
          newRow.rep = row.rep;
          newRow.calc = row.calc;
          newRow.product = row.product;
          newRow.dispQty = row.dispQty;
          newRow.directionId = row.directionId;
          newRow.pcks = row.pcks;
          newRow.bp = row.bp;
          newRow.nd = row.nd;
          newRow.ICDCode = row.ICDCode;
          newRow.PacksizeName = row.PacksizeName;
          newRow.RouteId = row.RouteId;
          newRow.BatchNo = row.BatchNo;
          newRow.ExpiryDate = row.ExpiryDate;
          newRow.SourceId = row.SourceId;
          newRow.SourceName = row.SourceName;
          newRow.CurrentStockQty = row.CurrentStockQty;
          newRow.BatchInfo = row.BatchInfo;
          newRow.ProductTypeId = row.ProductTypeId;

          // rows.push(newRow);

          let curItemForDelete = [row.id];
          existingItemsDelete = curItemForDelete.concat(existingItemsDelete);

        });


        // console.log('existingItemsDelete: ', existingItemsDelete);
        setDeletedDataSet(existingItemsDelete);
        formData["deletedDataSet"] = existingItemsDelete;
        formData["details"] = rows;


        // console.log("rows after pick protocol: ", rows);

        setManyTableData(rows);
        productAdd(rows);
        handleClose("Protocol");
        return protocolItems;
      }),
    {
      refetchOnWindowFocus: false,
      enabled: false,
    }
  );

  const addProtocol = (NonOrderProductData) => {

    if (!NonOrderProductData || NonOrderProductData.length === 0) return;

    let ProtocolId = NonOrderProductData[0].ProtocolId;
    let RegimenId = NonOrderProductData[0].RegimenId;

    setProtocolId(ProtocolId);
    setRegimenId(RegimenId);

    formData["ProtocolId"] = ProtocolId;
    formData["RegimenId"] = RegimenId;
  };

  useEffect(() => {
    // console.log("Calling protocol items useeffect");
    if (protocolId > 0) {
      fetchProtocolItemsData();
    }
  }, [protocolId]);

  const addProductBatch = (productBatchData) => {
    if (!productBatchData) {
      return;
    }

    // console.log("rows before pick product: ", manyTableData);
    // console.log("Product batch selected data: ", productBatchData);
    // console.log("Product batch selected currRowId: ", currRowId);

    let rows = [];
    let autoId = Date.now(); // 0;

    manyTableData.forEach((row, i) => {
      autoId++;
      let newRow = {};

      if (row.id === currRowId) {

        
        // let bInfo = [
        //   {
        //     "ItemNo": temProductBatchData.ItemNo,
        //     "Batch": temProductBatchData.BatchNo,
        //     "ExpiryDate": temProductBatchData.ExpiryDate,
        //     "SourceId": temProductBatchData.SourceId,
        //     "CurrStock": temProductBatchData.CurrentStockQty,
        //     "Pcks": temProductBatchData.Pcks
        //   }
        // ];

        let bInfo = [];

        let totalBatchPcks = 0;
        productBatchData.forEach(element => {
          // console.log('element: ', element);
          // if(element.Pcks>0){
          //   tmpTotalPcks+=parseInt(element.Pcks);
          //   console.log('element yyeeeesssssss: ', element);
          //   qtyBatchList.push(element);
          // }

          bInfo.push({
            "ItemNo": element.ItemNo,
            "Batch": element.BatchNo,
            "ExpiryDate": element.ExpiryDate,
            "SourceId": element.SourceId,
            "CurrStock": element.CurrentStockQty,
            "Pcks": element.Pcks,
            "ProductTypeId": element.ProductTypeId
          });
          totalBatchPcks+=parseInt(element.Pcks);
          
        });

        
        let temProductBatchData = productBatchData[0];
        // console.log("This is my row: ", row);
        // console.log("This is my row: ", temProductBatchData);
        newRow.productId = temProductBatchData.ItemNo;
        newRow.UnitPrice = temProductBatchData.UnitPrice;
        newRow.product = temProductBatchData.ItemName;
        newRow.PacksizeName = temProductBatchData.PacksizeName;
        newRow.RouteId = temProductBatchData.RouteId;
        newRow.CurrentStockQty = temProductBatchData.CurrentStockQty;

        newRow.BatchNo = temProductBatchData.BatchNo;
        newRow.ExpiryDate = temProductBatchData.ExpiryDate;
        newRow.SourceId = temProductBatchData.SourceId;
        newRow.SourceName = temProductBatchData.SourceName;
        newRow.ProductTypeId = temProductBatchData.ProductTypeId;

        // let tmpPcks = Math.ceil(row.calc / temProductBatchData.PacksizeName);
        let tmpPcks = Math.ceil(totalBatchPcks);
        newRow.pcks = tmpPcks;
        newRow.dispQty = tmpPcks * temProductBatchData.PacksizeName;

        // let bInfo = [
        //   {
        //     "ItemNo": 20,
        //     "Batch": "LOT0002",
        //     "ExpiryDate": "2023-03-10",
        //     "SourceId": 5,
        //     "CurrStock": 500,
        //     "Pcks": 6
        //   },
        //   {
        //     "ItemNo": 21,
        //     "Batch": "LOT0002",
        //     "ExpiryDate": "2023-05-20",
        //     "SourceId": 6,
        //     "CurrStock": 700,
        //     "Pcks": 15
        //   }
        // ];

        newRow.BatchInfo = bInfo;


      } else {
        newRow.productId = row.productId;
        newRow.UnitPrice = row.UnitPrice;
        newRow.product = row.product;
        newRow.PacksizeName = row.PacksizeName;
        newRow.RouteId = row.RouteId;
        newRow.BatchNo = row.BatchNo;
        newRow.ExpiryDate = row.ExpiryDate;
        newRow.SourceId = row.SourceId;
        newRow.SourceName = row.SourceName;
        newRow.pcks = row.pcks;
        newRow.dispQty = row.dispQty;
        newRow.CurrentStockQty = row.CurrentStockQty;
        newRow.BatchInfo = row.BatchInfo;
        newRow.ProductTypeId = row.ProductTypeId;
      }

      newRow.id = row.id;
      newRow.formulation = row.formulation;
      newRow.type = row.type;
      newRow.qty = row.qty;
      newRow.uom = row.uom;
      newRow.AdministrationUnit = row.AdministrationUnit;
      newRow.intervalId = row.intervalId;
      newRow.dur = row.dur;
      newRow.rep = row.rep;
      newRow.calc = row.calc;
      newRow.directionId = row.directionId;
      newRow.bp = row.bp;
      newRow.nd = row.nd;
      newRow.ICDCode = row.ICDCode;

      rows.push(newRow);
    });

    // console.log("rows after link with product: ", rows);

    setManyTableData(rows);
    productAdd(rows);
    handleClose("ProductBatch");
  };

  useEffect(() => {
    setManyTableData(formData.details);

    if (formData.details.length > 0) {
      // console.log("formData.details[0]: ", formData.details[0]);
      setSelectedPrescriptionItem(formData.details[0]);

      if(itemMasterId != formData.details[0].id){
        tmpItemMasterId = formData.details[0].id;
        getPrescriptionItemBatchs(formData.details[0]);
      }
 

    } else {
      // console.log("formData.details[0]: {}");
      setSelectedPrescriptionItem({});
      tmpItemMasterId = 0;
      getPrescriptionItemBatchs({});

    }

    //set for enable/diable flag
    if (formData.status === -1) {
      setbIsEnable(false);
    } else {
      setbIsEnable(true);
    }
  }, [formData.details]);

  const handleChangeToggleButton = (event, tmpToggleBtnValue) => {
    if (tmpToggleBtnValue) {
      // console.log('tmpToggleBtnValue: ', tmpToggleBtnValue);
      setToggleBtn(tmpToggleBtnValue);
    }
  };

  function getTotalCFA() {
    let totalCFA = 0;
    if (formData.details.length > 0) {
      formData.details.forEach((row, i) => {
        let UnitPrice = row.UnitPrice;
        let dispQty = row.dispQty;

        totalCFA += UnitPrice * dispQty;
      });
    }

    // handleRDateChange(10, "cost");
    // handleRDateChange(101, "finalCost");
    return totalCFA.toFixed(1);
  }

  function getMaxRepeats() {
    // console.log("calling getMaxRepeats");
    let maxRep = 0;
    if (formData.details.length > 0) {
      formData.details.forEach((row, i) => {
        if (row.rep > maxRep) {
          maxRep = row.rep;
        }
      });
    }
    // console.log("maxRep: ", maxRep);
    return maxRep;
  }

  function RowInputData(props: any, type = null) {
    const rowData = props.cell._cell.row.data;
    let fieldName = props.field;
    let fieldType = props.fieldType;
    let labelName = props.labelName;
    let dropDownKey = props.dropDownKey;

    switch (fieldType) {
      case "text":
        return (
          <>
            <TextField variant="standard"
              id={fieldName}
              name={fieldName}
              type="number"
              value={rowData[fieldName] ?? ""}
              fullWidth
              autoComplete="family-name"
              onChange={(e) => handleDetailChange(e, rowData)}
            />
          </>
        );
        break;

      case "drop-down-interval":
        return (
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            // disabled={!!bIsDisable}
            disabled={!!(bIsDisable || formData.RepeatFromPrescriptionId > 0)}
            fullWidth
            name={fieldName}
            value={rowData[fieldName] ?? ""}
            onChange={(e) => handleDetailDropDownChange(e, rowData)}
            variant="standard"
            disableUnderline
          >
            {IntervalList.map((item) => {
              return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
            })}
          </Select>
        );
        break;

      case "drop-down-direction":
        return (
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            disabled={!!bIsDisable}
            fullWidth
            name={fieldName}
            value={rowData[fieldName] ?? ""}
            onChange={(e) => handleDetailDropDownChange(e, rowData)}
            variant="standard"
            disableUnderline
          >
            {DirectionList.map((item) => {
              return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
            })}
          </Select>
        );
        break;

      case "check-box":
        return rowData.type == "protocol" && fieldName == "nd" ? (
          <></>
        ) : (
          <Checkbox
            color="primary"
            disabled={!!bIsDisable}
            checked={Boolean(rowData[fieldName])}
            onChange={(e) => handleDetailCheck(e, rowData)}
            name={fieldName}
            value={fieldName}
          />
        );
        break;

      default:
        return <></>;
        break;
    }
    return <></>;
  }

  function ShowProductBatchPopup(props: any) {
    const rowData = props.cell._cell.row.data;
    // const cellValue = props.cell._cell.value || 'Edit | Show';

    // let isView = 0;
    // if(rowData.status === -1){
    //   isView = 1;
    // }
    if (bIsDisable) {
      return <></>;
    } else {
      return (
        <>
          <ViewList
            onClick={() => {
              // editPrescription(rowData);
              // console.log("Showing product and batch popup");
              // console.log("rowData when show product batch popup: ", rowData);
              // console.log("rowData.formulation: ", rowData.formulation);
              setCurrRowId(rowData.id);
              setCurrFormulation(rowData.formulation);

              handleClose("ProductBatchOpen");
            }}
          />
        </>
      );
    }
  }

  const prescriptionItemRowClick = (e: any, row: any) => {
    // alert(44);
    // console.log('e: any: ', e);
    // console.log('row: any: ',row);
    // console.log("Prescription Item selected row._row.data: ", row._row.data);

    // console.log("formDataformData setFormData: ", setFormData);
    // console.log("formDataformData: ", getCurrFormData);

    setSelectedPrescriptionItem(row._row.data);

    if(tmpItemMasterId != row._row.data.id){
      tmpItemMasterId = row._row.data.id;
      getPrescriptionItemBatchs(row._row.data);
    }
    
  };

  function generateProductLabel() {
    if (Object.keys(selectedPrescriptionItem).length) {
      // console.log("selectedPrescriptionItem: ", selectedPrescriptionItem);
      // console.log("selectedPrescriptionItem length: ",Object.keys(selectedPrescriptionItem).length);
      let intId = selectedPrescriptionItem.intervalId;
      // console.log("intId: ", intId);
      let singleIntervalInfo = IntervalList.filter((fa) => fa.id == intId)[0];
      // console.log("singleIntervalInfo: ", singleIntervalInfo.id);

      //   const newLine = "\r\n";
      //   console.log('currFacilityInfo: ', currFacilityInfo);

      //   console.log('rowData.length: ', rowData.length);
      //   let prodLabel = "";
      //   // if(rowData.length > 0){
      //     prodLabel += rowData.product +' ['+ rowData.dispQty +' x '+rowData.uom+'(s)]';

      //     prodLabel += currFacilityInfo[0].FacilityAddress + ', T: ' + currFacilityInfo[0].FacilityPhone + ' ' + currFacilityInfo[0].FacilityAddress;

      // // }
      // console.log('prodLabel: ', prodLabel);

      /*
    Diadanosine 250mg (Capsole) [30 x capsule (s)]
    Take 1 capsule once a day
    THIS IS A TEST (Repeats = Nil] XXXX, YYYY – Rx# RFMP/08/00081/0 XXXX, YYYY – Rx# RFMP/08/00081/0 RFM ART Centre T:O (21-Aug-2021) Box 14, Cotonou, Benin
    RFM ART Centre T:O (21-Aug-2021) Box 14, Cotonou, Benin
    Box 14, Cotonou, Benin
*/
    }
  }

  const columns = [
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      headerSort: false,
      headerHozAlign: "center",
      hozAlign: "center",
      width: 60,
      formatter: reactFormatter(<ActionButton />),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Formulation"]),
      field: "formulation",
      // width: 135,
      hozAlign: "left",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Qty"]),
      field: "qty",
      width: 50,
      hozAlign: "right",
      headerHozAlign: "right",
      headerSort: false,

      validator: ["integer", "min:1"],
      cssClass: "tabluator-column-editable",
      // editor: bIsDisable == 0 ? cellFocusEditor : "",
      editor:
        bIsDisable || formData.RepeatFromPrescriptionId > 0
          ? ""
          : cellFocusEditor,
      // editor: cellFocusEditor,
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const curcol = cell.getField();
        const rowdata = currow.getData();

        // console.log('cell: ', cell);
        // console.log('cell: ', cell.getField());
        setUpdatedDetailsGridDataHandler(rowdata, curcol);
      },
      // formatter: reactFormatter(
      //   <RowInputData labelName="Qty" field="qty" fieldType="text" />
      // ),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Uom"]),
      field: "uom",
      width: 55,
      hozAlign: "left",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Int"]),
      field: "intervalId",
      width: 80,
      headerSort: false,
      formatter: reactFormatter(
        <RowInputData
          labelName="Int"
          field="intervalId"
          fieldType="drop-down-interval"
          dropDownKey="INTERVALS"
        />
      ),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Dur"]),
      field: "dur",
      width: 50,
      hozAlign: "right",
      headerHozAlign: "right",
      headerSort: false,
      // formatter: reactFormatter(
      //   <RowInputData labelName="Dur" field="dur" fieldType="text" />
      // ),
      validator: ["integer", "min:1"],
      cssClass: "tabluator-column-editable",
      // editor: bIsDisable == 0 ? cellFocusEditor : "",
      editor:
        bIsDisable || formData.RepeatFromPrescriptionId > 0
          ? ""
          : cellFocusEditor,
      // editor: cellFocusEditor,
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const curcol = cell.getField();
        const rowdata = currow.getData();

        // console.log('cell: ', cell);
        // console.log('cell: ', cell.getField());

        setUpdatedDetailsGridDataHandler(rowdata, curcol);
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Rep"]),
      field: "rep",
      width: 50,
      hozAlign: "right",
      headerHozAlign: "right",
      headerSort: false,
      // formatter: reactFormatter(
      //   <RowInputData labelName="Rep" field="rep" fieldType="text" />
      // ),
      validator: ["integer", "min:0", "max:6"],
      cssClass: "tabluator-column-editable",
      // editor: bIsDisable == 0 ? cellFocusEditor : "",
      editor:
        bIsDisable || formData.RepeatFromPrescriptionId > 0
          ? ""
          : cellFocusEditor,
      // editor: cellFocusEditor,
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const curcol = cell.getField();
        const rowdata = currow.getData();

        // console.log('cell: ', cell);
        // console.log('cell: ', cell.getField());

        setUpdatedDetailsGridDataHandler(rowdata, curcol);
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Calc"]),
      field: "calc",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 55,
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product"]),
      field: "product",
      hozAlign: "left",
      // width: 220,
      headerSort: false,
    },

    {
      title: "",
      headerSort: false,
      field: "custom",
      hozAlign: "center",
      width: 8,
      formatter: reactFormatter(<ShowProductBatchPopup />),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Pcks"]),
      field: "pcks",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 55,
      headerSort: false,

      // validator: ["integer", "min:0"],
      // cssClass: "tabluator-column-editable",
      // editor: bIsDisable == 0 ? cellFocusEditor : "",
      // cellEdited: function (cell) {
      //   const curcellval = cell.getValue();
      //   const currow = cell.getRow();
      //   const curcol = cell.getField();
      //   const rowdata = currow.getData();

      //   setUpdatedDetailsGridDataHandler(rowdata, curcol);
      // },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Disp Qty"]),
      field: "dispQty",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 75,
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Uom"]),
      field: "uom",
      width: 55,
      hozAlign: "left",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Dir"]),
      field: "directionId",
      hozAlign: "left",
      headerHozAlign: "left",
      width: 130,
      headerSort: false,
      formatter: reactFormatter(
        <RowInputData
          labelName="Dir"
          field="directionId"
          fieldType="drop-down-direction"
          dropDownKey="DIRECTIONS"
        />
      ),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["BP"]),
      field: "bp",
      hozAlign: "center",
      vertAlign: "middle",
      width: 37,
      headerSort: false,
      formatter: reactFormatter(
        <RowInputData labelName="BP" field="bp" fieldType="check-box" />
      ),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["ND"]),
      field: "nd",
      hozAlign: "center",
      vertAlign: "middle",
      width: 37,
      headerSort: false,
      formatter: reactFormatter(
        <RowInputData labelName="ND" field="nd" fieldType="check-box" />
      ),
    },
    {
      title: "Pack Size",
      field: "PacksizeName",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 55,
      visible: false,
      headerSort: false,
    },
    {
      title: "Unit Price",
      field: "UnitPrice",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 55,
      visible: false,
      headerSort: false,
    },
    {
      title: "Current Stock",
      field: "CurrentStockQty",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 55,
      visible: false,
      headerSort: false,
    },
    {
      title: "Route Id",
      field: "RouteId",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 20,
      visible: false,
      headerSort: false,
    },
    {
      title: "ProductTypeId",
      field: "ProductTypeId",
      visible: false
    }
  ];

  const deletePrescriptionItem = (data) => {
    
    let newarray = manyTableData.filter((element) => element !== data);

    setManyTableData(newarray);

    if (data.id != null) {
      let newDeletedDataSet = [data.id];

      setDeletedDataSet(newDeletedDataSet.concat(deletedDataSet));

      formData["deletedDataSet"] = newDeletedDataSet.concat(deletedDataSet);

      formData["details"] = newarray;
    }

  };

  function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;

    //const cellValue = props.cell._cell.value || "Edit | Show";
    // console.log('formData.RepeatFromPrescriptionId: ', formData.RepeatFromPrescriptionId);
    if (bIsDisable) {
      return <></>;
    } else if (formData.RepeatFromPrescriptionId > 0) {
      //when RepeatFromPrescriptionId>0 then is's auto copy prescription
      return <></>;
    } else {
      return (
        <>
          <DeleteOutline
            onClick={() => {
              deletePrescriptionItem(rowData);
            }}
          />
        </>
      );
    }
  }



  const getPrescriptionItemBatchs = (prescriptionSelectedItem) => {


    // console.log('prescriptionSelectedItemaaaaaaaaaaaaaa: ', prescriptionSelectedItem);
    let presItem = Object.keys(prescriptionSelectedItem).length;
    // console.log('prescriptionSelectedItem length: ', presItem);
    // console.log('SourceList: ', SourceList);
    if (presItem > 0) {
      // console.log("prescriptionSelectedItem: ", prescriptionSelectedItem);
      // console.log("prescriptionSelectedItem.BatchInfo: ",prescriptionSelectedItem.BatchInfo);

      // const productBatchInfo = JSON.parse(prescriptionSelectedItem.BatchInfo);
      const productBatchInfo = prescriptionSelectedItem.BatchInfo;
      // console.log("productBatchInfo: ", productBatchInfo);

      let batchList = [];
      if (productBatchInfo) {
        productBatchInfo.forEach((row, i) => {
          // console.log("row: ", row);

          let SourceName = null;
          if(row.SourceId){
            SourceName = SourceList.filter((fa) => fa.id == row.SourceId)[0].name;
          }
          
          let batch = {
            ItemNo: row.ItemNo,
            Product: Itemlist.filter((fa) => fa.id == row.ItemNo)[0].nameshort,
            // Product: prescriptionSelectedItem.product,
            Batch: row.Batch,
            ExpiryDate: row.ExpiryDate,
            SourceId: row.SourceId,
            Source: SourceName,
            CurrStock: row.CurrStock,
            Pcks: row.Pcks,
            // MasterItemId: prescriptionSelectedItem.id,
          };

          batchList.push(batch);
        });

         setSelectedItemBatches(batchList);
       
        // setSelectedItemBatches([
        //   {
        //     "ItemNo": "20",
        //     "Product": "ABC/3TC 120/60mg TAB-CAP, [PO]",
        //     "Batch": "LOT0001",
        //     "ExpiryDate": "2022-03-30",
        //     "SourceId": "5",
        //     "Source": "Global Fund",
        //     "CurrStock": "500",
        //     "Pcks": prescriptionSelectedItem.id
        //   },
        //   {
        //     "ItemNo": "21",
        //     "Product": "AZT/3TC 300/150mg TAB-CAP, 60 tablet [PO]",
        //     "Batch": "LOT0002",
        //     "ExpiryDate": "2023-05-20",
        //     "SourceId": "6",
        //     "Source": "UNICEF",
        //     "CurrStock": "700",
        //     "Pcks": "6"
        //   }
        // ]);

      }else {
        setSelectedItemBatches([]);
      }
    } else {
      setSelectedItemBatches([]);
    }

  };

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        {/* <div className="d-flex justify-product mb-3">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading text-center">
              <div className="sw_heading_title_inner">
                {DispensingLanguage[lan][menukey]["Prescription Details"]}
              </div>
            </div>
          </Grid>
        </div> */}

        <div className="sw_relative">
          {/* {isLoadingIndicator && <LoadingSpinnerOpaque />} */}

          {/* New row */}
          <Grid container spacing={3}>
            <Grid item xs={3} sm={3}>
              <div className="sw_page_heading">
                <div className="sw_heading_title_inner">
                  {t(DispensingLanguage[lan][menukey]["Prescription Details"])}
                </div>
              </div>
            </Grid>

            <Grid item xs={9} sm={9}>
              <div className="float-end sw_btn_control">
                {AddRecord == true ? (
                  <Button
                    className="me-2 mb-3"
                    variant="contained"
                    color="primary"
                    disabled={formBusy}
                    onClick={() => handleSubmit()}
                  >
                    {t(DispensingLanguage[lan][menukey]["Save"])}
                  </Button>
                ) : (
                  <Button
                    className="me-2 mb-3"
                    variant="contained"
                    color="primary"
                    disabled={!!(bIsDisable || formBusy)}
                    onClick={() => updatePrescription()}
                  >
                    {t(DispensingLanguage[lan][menukey]["update"])}
                  </Button>
                )}

                {AddRecord == true && (
                  <Button
                    className="me-2 mb-3"
                    variant="contained"
                    color="primary"
                    disabled={formBusy}
                    onClick={() => handleReset()}
                  >
                    {t(DispensingLanguage[lan][menukey]["Reset"])}
                  </Button>
                )}

                {/* {
                  // formData.status != "Draft" &&
                  formData.status != 1 && (
                    <Button
                      variant="contained"
                      className="me-2 mb-3"
                      color="primary"
                      onClick={(e) => changePrescriptionStatus("Draft")}
                    >
                      {t(DispensingLanguage[lan][menukey]["DRAFT"])}
                    </Button>
                  )
                } */}
                {
                  // formData.status != "Posted" &&
                  AddRecord != true && formData.status != 2 && (
                    <Button
                      variant="contained"
                      className="me-2 mb-3"
                      color="primary"
                      disabled={!!(bIsDisable || formBusy)}
                      onClick={(e) => changePrescriptionStatus("Posted")}
                    >
                      {t(DispensingLanguage[lan][menukey]["POST"])}
                    </Button>
                  )
                }
                {
                  // formData.status != "Stop" &&
                  AddRecord != true && formData.status != 3 && (
                    <Button
                      variant="contained"
                      className="me-2 mb-3"
                      color="primary"
                      disabled={!!(bIsDisable || formBusy)}
                      onClick={(e) => changePrescriptionStatus("Stop")}
                    >
                      {t(DispensingLanguage[lan][menukey]["CANCEL/STOP"])}
                    </Button>
                  )
                }
                {
                  // formData.status != "Not Collected" &&
                  AddRecord != true && formData.status != 4 && (
                    <Button
                      variant="contained"
                      className="me-2 mb-3"
                      color="primary"
                      disabled={!!(bIsDisable || formBusy)}
                      onClick={(e) => changePrescriptionStatus("NotCollected")}
                    >
                      {t(DispensingLanguage[lan][menukey]["NOT COLLECTED"])}
                    </Button>
                  )
                }
                {
                  // formData.status != "Copy" &&
                  AddRecord != true && formData.status != 5 && formData.status != -1 && (
                    <Button
                      variant="contained"
                      className="me-2 mb-3"
                      color="primary"
                      disabled={!!(formBusy || props.permissionType)}

                      onClick={(e) => changePrescriptionStatus("Copy")}
                    >
                      {t(DispensingLanguage[lan][menukey]["COPY"])}
                    </Button>
                  )
                }

                <Button
                  className="me-2 mb-3"
                  variant="contained"
                  color="gray"
                  type="reset"
                  onClick={() => props.history.push("/prescription")}
                >
                  {t(DispensingLanguage[lan][menukey]["Back to List"])}
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  className="me-2 mb-3 sw_icons"
                  onClick={() => PrintMany()}
                >
                  <i className="fas fa-print"></i>
                </Button>
              </div>
            </Grid>
          </Grid>

          {/* New row */}
          <Grid container spacing={3}>
            <Grid item xs={4} sm={4}>
              <Typography
                variant="body2"
                component="p"
                className="sw_text_label"
              >
                <strong>
                  {t(DispensingLanguage[lan][menukey]["ID Number"])} :
                </strong>{" "}
                {formData.idNumber}
              </Typography>
            </Grid>

            <Grid item xs={3} sm={3}>
              <Typography
                variant="body2"
                component="p"
                className="sw_text_label"
              >
                {formData.prescriptionNumbar && (
                  <span>
                    <strong>
                      {t(DispensingLanguage[lan][menukey]["Prescription#"])} :{" "}
                    </strong>{" "}
                    {formData.prescriptionNumbar}{" "}
                  </span>
                )}
              </Typography>
            </Grid>

            {AddRecord != true && (
              <Grid item xs={5} sm={5}>
                <Typography
                  variant="body2"
                  component="p"
                  className="sw_text_label"
                >
                  <strong>
                    {t(DispensingLanguage[lan][menukey]["Status"])} :
                  </strong>{" "}
                  {formData.RepeatFromPrescriptionId && (
                    <>
                      {t(DispensingLanguage[lan][menukey]["Repeated"])}
                      {"-"}
                    </>
                  )}
                  {formData.StatusName}
                  {formData.PostDate}
                </Typography>
              </Grid>
            )}

            {/* new row */}
            <Grid item xs={12} sm={12} className="mb-3">
              <Grid container spacing={3}>
                {/* New row */}
                <Grid item xs={4} sm={4}>
                  <Grid container spacing={3}>
                    <Grid item xs={6} sm={6}>
                      <TextField variant="standard"
                        required
                        id="PatientNo"
                        name="PatientNo"
                        label={t(DispensingLanguage[lan][menukey]["PAS#"])}
                        // value={patientData.id}
                        value={formData.patientIdNumber ?? ""}
                        fullWidth
                        disabled={true}
                        autoComplete="family-name"
                        // onChange={(e) => handleChange(e)}
                      />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                      <TextField variant="standard"
                        //required
                        id="ipn"
                        name="ipn"
                        label={t(DispensingLanguage[lan][menukey]["IPN#"])}
                        // value={patientData.id}
                        value={formData.ipn ?? ""}
                        fullWidth
                        disabled={true}
                        autoComplete="family-name"
                        // onChange={(e) => handleChange(e)}
                      />
                    </Grid>
                  </Grid>
                  {/* New row */}

                  {/* now hide clinic. sir told 2021 11 15 */}
                  {false && (
                    <Grid item xs={12} sm={12}>
                      <FormControl variant="standard" className={classes.fullWidth}>
                        <InputLabel id="demo-simple-select-helper-label">
                          {t(DispensingLanguage[lan][menukey]["Clinic"])}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="demo-simple-select-helper"
                          name="ClinicId"
                          value={formData.ClinicId ?? ""}
                          fullWidth
                          onChange={(e) => handleChange(e)}
                        label={t(DispensingLanguage[lan][menukey]["Clinic"])}>
                          {FacilityList.map((item, index) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}

                  {/* New row */}
                  <Grid item xs={12} sm={12}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={4}>
                          <FormControl component="fieldset">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    disabled={!!bIsDisable}
                                    checked={formData.referred}
                                    onChange={(e) => handleCheck(e)}
                                    name="referred"
                                    value="referred"
                                  />
                                }
                                label={t(DispensingLanguage[lan][menukey]["referred"])}
                              />

                              <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    disabled={!!bIsDisable}
                                    checked={formData.new}
                                    onChange={(e) => handleCheck(e)}
                                    name="new"
                                    value="new"
                                  />
                                }
                                label={t(DispensingLanguage[lan][menukey]["New"])}
                              />
                            
                              {/* <FormControlLabel
                                control={
                                  <Checkbox
                                    color="primary"
                                    disabled={!!bIsDisable}
                                    checked={false}
                                    checked={formData.pregnant}
                                    onChange={(e) => handleCheck(e)}
                                    name="pregnant"
                                    value="new"
                                  />
                                }
                                label={t(DispensingLanguage[lan][menukey]["Pregnant"])}
                              /> */}

                          </FormControl>

                      </Grid>

                      <Grid item xs={12} sm={8} className={classes.remarksMarginTop}>
                          <FormControl variant="standard" className={classes.fullWidth}>
                            <InputLabel id="demo-simple-select-helper-label">
                              {t(DispensingLanguage[lan][menukey]["Dispenser"] + "*")}
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-helper-label"
                              id="demo-simple-select-helper"
                              disabled={!!bIsDisable}
                              name="dispenser"
                              value={formData.dispenser ?? ""}
                              fullWidth
                              onChange={(e) => handleChange(e)}
                            label={t(DispensingLanguage[lan][menukey]["Dispenser"] + "*")}>
                              {/* {
                              Constants.DROP_DOWN_OPTIONS.DISPENSERS.map((item) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                )
                              })
                            } */}

                              {DispenserList.map((item, index) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText error={!!errorObject.dispenser}>
                              {errorObject.dispenser}
                            </FormHelperText>
                          </FormControl>
                      </Grid>

                        {/* <Grid item xs={12} sm={8} className={classes.remarksMarginTop}>

                          <TextField variant="standard"
                            id="Remarks"
                            name="Remarks"
                            label={t(DispensingLanguage[lan][menukey]['Remarks'])}
                            value={formData.Remarks}
                            fullWidth
                            multiline
                            onChange={(e) => handleChange(e)}
                            disabled={!!bIsDisable}
                          />
                        </Grid> */}

                    </Grid>
                  </Grid>

                  {!bIsDisable && AddRecord != true && (
                    <Grid item xs={12} sm={12} className="dnone">
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                                                <DatePicker
                            label="Post Date"
                            disabled={!!bIsDisable}
                            value={formData.currentDate}
                            inputFormat="dd/MM/yyyy"
                            onChange={(e) => handleRDateChange(e, "currentDate")}
                                                    renderInput={(params) => (
                            <TextField
                              {...params}
                              value={params.value ?? ""}
                              variant="standard"
                              className={classes.fullWidth}
                              fullWidth
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>
                  )}
                </Grid>

                {/* New row */}
                <Grid item xs={8} sm={8}>
                  <Grid container spacing={3}>
                    {/* New row */}
                    <Grid item xs={6} sm={6}>
                      <FormControl variant="standard" className={classes.fullWidth}>
                        <InputLabel id="demo-simple-select-helper-label">
                          {t(DispensingLanguage[lan][menukey]["Demander"] + "*")}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="demo-simple-select-helper"
                          disabled={true}
                          name="demander"
                          value={formData.demander ?? ""}
                          fullWidth
                          onChange={(e) => handleChange(e)}
                        label={t(DispensingLanguage[lan][menukey]["Demander"] + "*")}>
                          {/* {
                          Constants.DROP_DOWN_OPTIONS.DEMANDERS.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            )
                          })
                        } */}

                          {FacilityList.map((item, index) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* New row */}
                    <Grid item xs={6} sm={6}>
                      <FormControl variant="standard" className={classes.fullWidth}>
                        <InputLabel id="demo-simple-select-helper-label">
                          {t(DispensingLanguage[lan][menukey]["Prescriber"] + "*")}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="demo-simple-select-helper"
                          disabled={!!bIsDisable}
                          name="prescriber"
                          value={formData.prescriber ?? ""}
                          fullWidth
                          onChange={(e) => handleChange(e)}
                        label={t(DispensingLanguage[lan][menukey]["Prescriber"] + "*")}>
                          {/* {
                          Constants.DROP_DOWN_OPTIONS.PRESCRIBERS.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            )
                          })
                        } */}

                          {PrescriberList.map((item, index) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                            );
                          })}
                        </Select>
                        <FormHelperText error={!!errorObject.prescriber}>
                          {errorObject.prescriber}
                        </FormHelperText>
                      </FormControl>
                    </Grid>

                    {/* New row */}
                    

                    {/* new row */}
                    <Grid item xs={3} sm={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                                                <DatePicker
                            label={
                            t(DispensingLanguage[lan][menukey][
                            "Prescription Date"
                            ])
                            }
                            disabled={!!bIsDisable}
                            value={formData.prescriptionDate || null}
                            inputFormat="dd/MM/yyyy"
                            onChange={(e) =>
                            handleRDateChange(e, "prescriptionDate")
                            }
                                                    renderInput={(params) => (
                            <TextField
                              {...params}
                              value={params.value ?? ""}
                              error={!!errorObject.prescriptionDate}
                              helperText={errorObject.prescriptionDate}
                              variant="standard"
                              className={classes.fullWidth}
                              fullWidth
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>

                    {/* new row */}
                    <Grid item xs={3} sm={3}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                                                <DatePicker
                            // required
                            label={
                            t(DispensingLanguage[lan][menukey]["Appointment Date"])
                            }
                            disabled={!!bIsDisable}
                            value={formData.appointmentDate || null}
                            inputFormat="dd/MM/yyyy"
                            onChange={(e) =>
                            handleRDateChange(e, "appointmentDate")
                            }
                                                    renderInput={(params) => (
                            <TextField
                              {...params}
                              value={params.value ?? ""}
                              variant="standard"
                              className={classes.fullWidth}
                              fullWidth
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={6} sm={6} >

                          <TextField variant="standard"
                            id="Remarks"
                            name="Remarks"
                            label={t(DispensingLanguage[lan][menukey]['Remarks'])}
                            value={formData.Remarks ?? ""}
                            fullWidth
                            multiline
                            maxRows={3}
                            onChange={(e) => handleChange(e)}
                            disabled={!!bIsDisable}
                          />
                    </Grid>



                    {/* hide protocolId and RegimenId */}
                    {false && (

                      <Grid item xs={2} sm={2}>
                        <TextField variant="standard"
                          id="ProtocolId"
                          name="ProtocolId"
                          value={formData.ProtocolId ?? ""}
                          fullWidth
                          autoComplete="family-name"
                          disabled={true}
                        />
                        <TextField variant="standard"
                          id="RegimenId"
                          name="RegimenId"
                          value={formData.RegimenId ?? ""}
                          fullWidth
                          autoComplete="family-name"
                          disabled={true}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* New row */}
            <Grid container spacing={3}>
              {/* <ProductsModal
              handleClose={handleClose}
              open={open}
              addProduct={addProduct}
              {...props}
            /> */}

              <PrescriptionItemModal
                handleClose={handleClose}
                open={open}
                addProduct={addProduct}
                {...props}
              />

              <ProtocolModal
                handleClose={handleClose}
                open={openProtocol}
                addProtocol={addProtocol}
                formData={formData}
                {...props}
              />

              <ProductSelectInPrescriptionModal
                handleClose={handleClose}
                open={openProductBatches}
                addProductBatch={addProductBatch}
                formulation={currFormulation}
                pselectedPrescriptionItem={selectedPrescriptionItem}
                {...props}
              />

              <Grid item xs={12}>
                <div className="float-end">
                  {/* <Button
                  variant="contained"
                  className="me-2 mb-3"
                  color="primary"
                  onClick={() => setShowProductListModel(true)}
                >
                  Select Product Virendra
                </Button> */}

                  <Button
                    disabled={!!bIsDisable}
                    className="me-2"
                    variant="contained"
                    color="primary"
                    onClick={() => handleClose("ProductsOpen")}
                  >
                    {t(DispensingLanguage[lan][menukey]["Select Product"])} {" "}
                  </Button>

                  <Button
                    disabled={!!bIsDisable}
                    className="me-2"
                    variant="contained"
                    color="primary"
                    onClick={() => handleClose("ProtocolOpen")}
                  >
                    {t(DispensingLanguage[lan][menukey]["Select Protocol"])} {" "}
                  </Button>
                </div>
              </Grid>
            </Grid>

            {/* new row */}
            {/* {formData.details && formData.details.length > 0 && ( */}

            <Grid item xs={12} sm={12}>
              <Card className="sw_card">
                <CardHeader
                  title={
                    t(DispensingLanguage[lan][menukey]["Prescription Details"])
                  }
                  action={
                    <Grid className="pt-3" item xs={12} sm={12}>
                      <ToggleButtonGroup
                        className="sw_ToggleButtonGroup"
                        color="primary"
                        value={toggleBtnValue}
                        exclusive
                        onChange={handleChangeToggleButton}
                      >
                        <ToggleButton value="1">
                          <ViewListSharp className="btn-theme-color" />{" "}
                          {
                            // "Table"
                          }
                        </ToggleButton>
                        <ToggleButton value="2">
                          <ViewComfySharp className="btn-theme-color" />{" "}
                          {
                            // "Label"
                          }
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Grid>
                  }
                ></CardHeader>

                {toggleBtnValue == 1 && (
                  <CardContent>
                    <ReactTabulator
                      options={{
                        selectableRowsRangeMode: "click",
                        selectableRows: 1,
                      }}
                      layout={"fitColumns"}
                      onRef={(r) => { PrescriptionItemsRef.table = r.current; }}
                      columns={columns}
                      // data={tmpData}
                      data={manyTableData}

                      events={{
                        rowClick: (e, row) => prescriptionItemRowClick(e, row),
                      }}


                    />
                  </CardContent>
                )}

                {toggleBtnValue == 2 && (
                  <CardContent>
                    <Grid container spacing={1}>
                      {manyTableData.map((SingleItem, index) => (
                        <Grid key={index} item xs={4} sm={4}>
                          {Object.keys(SingleItem).length && (
                            <List className="sw_list card-list">
                              {SingleItem.productId && (
                                <ListItem>
                                  <ListItemText
                                    primary={
                                      SingleItem.product +
                                      " [" +
                                      SingleItem.dispQty +
                                      " x " +
                                      SingleItem.uom +
                                      "(s)]"
                                    }
                                  />
                                </ListItem>
                              )}

                              {SingleItem.productId && (
                                <ListItem>
                                  <ListItemText
                                    primary={
                                      RouteOfAdminlist.filter(
                                        (fa) => fa.id == SingleItem.RouteId
                                      )[0].instruction +
                                      " " +
                                      SingleItem.qty +
                                      " " +
                                      SingleItem.uom +
                                      " " +
                                      (SingleItem.intervalId == 1
                                        ? ""
                                        : IntervalList.filter(
                                            (fa) =>
                                              fa.id == SingleItem.intervalId
                                          )[0].instruction) +
                                      " " +
                                      (SingleItem.directionId == 1
                                        ? ""
                                        : DirectionList.filter(
                                            (fa) =>
                                              fa.id == SingleItem.directionId
                                          )[0].name)
                                    }
                                  />
                                </ListItem>
                              )}

                              <ListItem>
                                <ListItemText
                                  primary={
                                    "Rx#: " +
                                    formData.prescriptionNumbar +
                                    " - [" +
                                    t(DispensingLanguage[lan][menukey][
                                      "Repeats Left"
                                    ]) +
                                    "= " +
                                    SingleItem.rep +
                                    "]"
                                  }
                                />
                              </ListItem>

                              {/* <ListItem>
                                <ListItemText
                                  primary={
                                    formData.firstName +
                                    " " +
                                    formData.lastName +
                                    " - [" +
                                    formData.patientContactNumber +
                                    "]"
                                  }
                                />
                              </ListItem> */}

                              <ListItem>
                                <ListItemText
                                  primary={
                                    FacilityList.filter(
                                      (fa) => fa.id == FacilityId
                                    )[0].name +
                                    ", T: " +
                                    FacilityList.filter(
                                      (fa) => fa.id == FacilityId
                                    )[0].FacilityPhone
                                  }
                                />
                              </ListItem>

                              <ListItem>
                                <ListItemText
                                  primary={
                                    FacilityList.filter(
                                      (fa) => fa.id == FacilityId
                                    )[0].FacilityAddress
                                  }
                                />
                              </ListItem>
                            </List>
                          )}
                        </Grid>
                      ))}
                    </Grid>
                  </CardContent>
                )}
              </Card>
            </Grid>

            {/* new row */}
            <Grid item xs={12} sm={12}>
              <Grid container spacing={3}>
                {toggleBtnValue == 1 && (
                  <Grid item xs={12} sm={12}>
                    <Card className="sw_card">
                      <CardHeader
                        title={t(DispensingLanguage[lan][menukey]["Item Details"])}
                      />

                      <CardContent>
                        <Grid container spacing={0}>
                          <Grid item xs={12} sm={12}>

                            {/* <Card className="sw_card mt-3">
                              <CardHeader
                                title={
                                  t(DispensingLanguage[lan][menukey][
                                    "Prescription Items"
                                  ])
                                }
                              />
                              <CardContent>
                                
                              </CardContent>
                            </Card> */}


                             <Grid container spacing={0}>
                                  <Grid item xs={12} sm={12}>
                                    <div className="uniqueName mb-2">
                                      <MaterialTable
                                        // tableRef={tableRef}
                                        title=""
                                        // icons={Service.default.tableicons()}
                                        columns={[
                                          {
                                            title: t(DispensingLanguage[lan][menukey]["Product"]),
                                            field: "Product",
                                            width: "35%",
                                            align: "left",
                                          },
                                          {
                                            title:
                                              t(DispensingLanguage[lan][menukey][
                                                "Batch#"
                                              ]),
                                            field: "Batch",
                                            width: "20%",
                                            align: "left",
                                          },
                                          {
                                            title:
                                              t(DispensingLanguage[lan][menukey][
                                                "Expiry Date"
                                              ]),
                                            field: "ExpiryDate",
                                            width: "15%",
                                            align: "left",
                                          },
                                          {
                                            title:
                                              t(DispensingLanguage[lan][menukey][
                                                "Source"
                                              ]),
                                            field: "Source",
                                            width: "15%",
                                            align: "left",
                                          },
                                          {
                                            title:
                                              t(DispensingLanguage[lan][menukey][
                                                "Pcks"
                                              ]),
                                            field: "Pcks",
                                            width: "15%",
                                            align: "right",
                                          },
                                        ]}
                                        // onSearchChange={setQuery}
                                        // data={getPrescriptionItemBatchs(selectedPrescription)}

                                        data={selectedItemBatches}
                                        options={{
                                          rowStyle: (rowData) => ({
                                            // backgroundColor:selectedRow === rowData.tableData.id? "#EEE": "#FFF",
                                          }),
                                          headerStyle: {
                                            position: "sticky",
                                            fontWeight: "bold",
                                          },
                                          search: false,
                                          sorting: false,
                                          paging: false,
                                          actionsColumnIndex: 0,
                                          toolbar: false,
                                        }}
                                        // onRowClick={(evt, selectedRow) =>
                                        //    setSelectedRow(selectedRow.tableData.id)
                                        // }
                                        actions={
                                          [
                                            // {
                                            //   icon: Service.default.tableicons().Edit,
                                            //   tooltip: "View/Edit",
                                            //   onClick: (event, rowData) => editPrescription(rowData),
                                            // },
                                            // {
                                            //   icon: Service.default.tableicons().Delete,
                                            //   tooltip: "Delete User",
                                            //   onClick: (event, rowData) => deleteRole(rowData),
                                            // },
                                          ]
                                        }
                                      />
                                    </div>
                                  </Grid>
                                </Grid> 












                            {/* {Object.keys(selectedPrescriptionItem).length && (
                              <List className="sw_list">
                                {selectedPrescriptionItem.productId && (
                                  <div>
                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          selectedPrescriptionItem.product
                                        }
                                      />
                                    </ListItem>

                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          t(DispensingLanguage[lan][menukey][
                                            "Batch#"
                                          ]) +
                                          ": " +
                                          (selectedPrescriptionItem.BatchNo ==
                                          null
                                            ? ""
                                            : selectedPrescriptionItem.BatchNo)
                                        }
                                      />
                                    </ListItem>

                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          t(DispensingLanguage[lan][menukey][
                                            "Expiry Date"
                                          ]) +
                                          ": " +
                                          (selectedPrescriptionItem.ExpiryDate ==
                                          null
                                            ? ""
                                            : selectedPrescriptionItem.ExpiryDate)
                                        }
                                      />
                                    </ListItem>

                                    <ListItem>
                                      <ListItemText
                                        primary={
                                          t(DispensingLanguage[lan][menukey][
                                            "Source"
                                          ]) +
                                          ": " +
                                          (selectedPrescriptionItem.SourceName ==
                                          null
                                            ? ""
                                            : selectedPrescriptionItem.SourceName)
                                        }
                                      />
                                    </ListItem>
                                  </div>
                                )}
                              </List>
                            )} */}

                    

                             
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                )}
                {/* new row */}
                {/* <Grid item xs={6} sm={6}>
                  <Card className="sw_card">
                    <CardHeader
                      title={t(DispensingLanguage[lan][menukey]["Label"])}
                    />
                    <CardContent>
                      <Grid container spacing={0}>
                        <Grid item xs={12} sm={12}>
                          {Object.keys(selectedPrescriptionItem).length && (
                            <List className="sw_list">
                              {selectedPrescriptionItem.productId && (
                                <ListItem>
                                  <ListItemText
                                    primary={
                                      selectedPrescriptionItem.product +
                                      " [" +
                                      selectedPrescriptionItem.dispQty +
                                      " x " +
                                      selectedPrescriptionItem.uom +
                                      "(s)]"
                                    }
                                  />
                                </ListItem>
                              )}

                              {selectedPrescriptionItem.productId && (
                                <ListItem>
                                  <ListItemText
                                    primary={
                                      RouteOfAdminlist.filter(
                                        (fa) =>
                                          fa.id ==
                                          selectedPrescriptionItem.RouteId
                                      )[0].instruction +
                                      " " +
                                      selectedPrescriptionItem.qty +
                                      " " +
                                      selectedPrescriptionItem.uom +
                                      " " +
                                      (selectedPrescriptionItem.intervalId == 1
                                        ? ""
                                        : IntervalList.filter(
                                            (fa) =>
                                              fa.id ==
                                              selectedPrescriptionItem.intervalId
                                          )[0].instruction) +
                                      " " +
                                      (selectedPrescriptionItem.directionId == 1
                                        ? ""
                                        : DirectionList.filter(
                                            (fa) =>
                                              fa.id ==
                                              selectedPrescriptionItem.directionId
                                          )[0].name)
                                    }
                                  />
                                </ListItem>
                              )}

                              <ListItem>
                                <ListItemText
                                  primary={
                                    "Rx#: " +
                                    formData.prescriptionNumbar +
                                    " - [" +
                                    t(DispensingLanguage[lan][menukey][
                                      "Repeats Left"
                                    ]) +
                                    "= " +
                                    selectedPrescriptionItem.rep +
                                    "]"
                                  }
                                />
                              </ListItem>

                              <ListItem>
                                <ListItemText
                                  primary={
                                    formData.firstName +
                                    " " +
                                    formData.lastName +
                                    " - [" +
                                    formData.patientContactNumber +
                                    "]"
                                  }
                                />
                              </ListItem>

                              <ListItem>
                                <ListItemText
                                  primary={
                                    FacilityList.filter(
                                      (fa) => fa.id == FacilityId
                                    )[0].name +
                                    ", T: " +
                                    FacilityList.filter(
                                      (fa) => fa.id == FacilityId
                                    )[0].FacilityPhone
                                  }
                                />
                              </ListItem>

                              <ListItem>
                                <ListItemText
                                  primary={
                                    FacilityList.filter(
                                      (fa) => fa.id == FacilityId
                                    )[0].FacilityAddress
                                  }
                                />
                              </ListItem>
                            </List>
                          )}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid> */}

                {/* new row */}
                <Grid item xs={6} sm={6}>
                  <Typography
                    style={{ fontSize: "25px" }}
                    className={classes.pos}
                    color="textSecondary"
                  >
                    {t(DispensingLanguage[lan][menukey]["Repeats"])} ={" "}
                    {getMaxRepeats()}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography
                    style={{ fontSize: "25px" }}
                    className={classes.pos}
                    color="textSecondary"
                  >
                    {t(DispensingLanguage[lan][menukey]["Items"])} ={" "}
                    {formData.details.length}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography
                    style={{ fontSize: "25px" }}
                    className={classes.pos}
                    color="textSecondary"
                  >
                    {getTotalCFA()} CFA
                  </Typography>
                </Grid>
              </Grid>

              <Grid item xs={12} className="mt-3 text-center">
                {/*               
              {AddRecord == true ? (
                <Button
                  className="me-2"
                  variant="contained"
                  color="primary"
                  onClick={() => handleSubmit()}
                >
                  {t(DispensingLanguage[lan][menukey]["Save"])}
                </Button>
              ) : (
                <Button
                  className="me-2"
                  variant="contained"
                  color="primary"
                  disabled={!!bIsDisable}
                  onClick={() => updatePrescription()}
                >
                  {t(DispensingLanguage[lan][menukey]["update"])}
                </Button>
              )}

              {AddRecord == true && (
                <Button
                  className="me-2"
                  variant="contained"
                  color="primary"
                  onClick={() => handleReset()}
                >
                  {t(DispensingLanguage[lan][menukey]["Reset"])}
                </Button>
              )}
              <Button
                className="me-2"
                variant="contained"
                color="gray"
                type="reset"
                onClick={() => props.history.push("/prescription")}
              >
                {t(DispensingLanguage[lan][menukey]["Back to List"])}
              </Button>
 */}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default PrescriptionForm;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  pos: {
    marginBottom: 12,
  },
  remarksMarginTop: {
    marginTop: "20px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
  th: {
    "border-left": "1px solid red",
  },
});
